/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
// import Button from "../Layout/Button";
import Button from "../../../../components/Layout/Button/index";
import Modal from "../../../../components/Modal/Modal";
// import Typography from "../Typography/Typography";
import Typography from "../../../../components/Typography/Typography";

export default function Alert({
  open,
  onClose,
  onSubmit,
  memberName,
  amount,
  paymentMethod,
  donationPurpose,
  chequeDDNo,
  chequeDDDate,
  payableCity,
  DrawnOnBank,
  otherBank,
  // isLoading,
}) {
  const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);

  const handleClick = () => {
    setIsButtonDisabled(true);
    onSubmit();
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 10000);
  };

  React.useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        handleClick();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <Box>
      <Modal
        open={open}
        onClose={onClose}
        // fullWidth="50%"
        // PaperProps={{ sx: { minHeight: 100 } }}
        // aria-labelledby="alert-dialog-title"
        // aria-describedby="alert-dialog-description"
      >
        <Typography
          style={{
            // color: "#8C8C8C",
            fontSize: "20px ",
            fontWeight: "500",
            paddingBottom: "20px",
          }}
        >
          PLEASE CONFIRM THE ENTERED DETAILS:
        </Typography>
        {memberName && (
          <Typography
            style={{
              // color: "#8C8C8C",
              fontSize: "16px ",
              fontWeight: "500",
              // paddingBottom: "20px",
            }}
          >
            Member Name: {memberName}
          </Typography>
        )}
        {amount && (
          <Typography
            style={{
              fontSize: "16px",
              fontWeight: "500",
            }}
          >
            Amount: {`${amount} INR`}
          </Typography>
        )}
        {paymentMethod && (
          <Typography
            style={{
              // color: "#8C8C8C",
              fontSize: "16px ",
              fontWeight: "500",
              // paddingBottom: "20px",
            }}
          >
            Payment Method: {paymentMethod}
          </Typography>
        )}
        {donationPurpose && (
          <Typography
            style={{
              // color: "#8C8C8C",
              fontSize: "16px ",
              fontWeight: "500",
              // paddingBottom: "20px",
            }}
          >
            Donation Purpose: {donationPurpose}
          </Typography>
        )}
        {chequeDDNo && (
          <Typography
            style={{
              // color: "#8C8C8C",
              fontSize: "16px ",
              fontWeight: "500",
              // paddingBottom: "20px",
            }}
          >
            Cheque/DD No: {chequeDDNo}
          </Typography>
        )}
        {chequeDDDate && (
          <Typography
            style={{
              // color: "#8C8C8C",
              fontSize: "16px ",
              fontWeight: "500",
              // paddingBottom: "20px",
            }}
          >
            Cheque/DD Date: {chequeDDDate}
          </Typography>
        )}
        {payableCity && (
          <Typography
            style={{
              // color: "#8C8C8C",
              fontSize: "16px ",
              fontWeight: "500",
              // paddingBottom: "20px",
            }}
          >
            Payable City: {payableCity}
          </Typography>
        )}
        {DrawnOnBank && (
          <Typography
            style={{
              // color: "#8C8C8C",
              fontSize: "16px ",
              fontWeight: "500",
              // paddingBottom: "20px",
            }}
          >
            Drawn On Bank: {DrawnOnBank}
          </Typography>
        )}
        {otherBank && (
          <Typography
            style={{
              // color: "#8C8C8C",
              fontSize: "16px ",
              fontWeight: "500",
              // paddingBottom: "20px",
            }}
          >
            Other Bank: {otherBank}
          </Typography>
        )}
        <Box
          style={{
            display: "flex",
            // paddingTop: "50px",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          {/* <Button
            onClick={onSubmit}
            label="Yes"
            style={{
              marginRight: "10px",
            }}
          /> */}
          <Button
            onClick={handleClick}
            width="40%"
            disabled={isButtonDisabled}
            style={{
              marginRight: "10px",
              //   width: "50%",
            }}
          >
            Yes
          </Button>
          <Button onClick={onClose} cancel width="40%">
            No
          </Button>
          {/* <Button onClick={onClose} label="No" variant="outlined" /> */}
        </Box>
      </Modal>
    </Box>
  );
}
